export default "/_next/static/images/5ba81a7695579ff931a75843b27eaf90.png";